var ol = require('../dist/ol-debug');

ol.TileQueue.prototype.handleTileChange = function(event) {
    var tile = /** @type {import("./Tile.js").default} */ (event.target);
    var state = tile.getState();
    if (!this.loadingSlots) {
        this.loadingSlots = [];
    }
    if (state === ol.TileState.LOADED || state === ol.TileState.ERROR ||
        state === ol.TileState.EMPTY || state === ol.TileState.ABORT) {
        ol.events.unlisten(tile, ol.events.EventType.CHANGE,
            this.handleTileChange, this);
        var tileKey = tile.getKey();
        if (tileKey in this.tilesLoadingKeys_) {
            delete this.tilesLoadingKeys_[tileKey];
            --this.tilesLoading_;
        }

        var indexOfTileSlot = this.loadingSlots.indexOf(tile);
        if (~this.loadingSlots.indexOf(tile)) {
            this.loadingSlots.splice(indexOfTileSlot, 1);
        }

        this.tileChangeCallback_();
    }
};

ol.TileQueue.prototype.loadMoreTiles = function(maxTotalLoading, maxNewLoads) {
    var newLoads = 0;
    var abortedTiles = false;
    var state, tile, tileKey;
    if (!this.loadingSlots) {
        this.loadingSlots = [];
    }
    while (this.tilesLoading_ < maxTotalLoading && newLoads < maxNewLoads &&
    this.getCount() > 0) {
        tile = /** @type {import("./Tile.js").default} */ (this.dequeue()[0]);
        tileKey = tile.getKey();
        state = tile.getState();
        if (state === ol.TileState.ABORT) {
            abortedTiles = true;
        } else if (state === ol.TileState.IDLE && !(tileKey in this.tilesLoadingKeys_)) {
            this.tilesLoadingKeys_[tileKey] = true;
            ++this.tilesLoading_;
            ++newLoads;
            this.loadingSlots.push(tile);
            tile.load();
        }
    }
    if (newLoads === 0 && abortedTiles) {
        // Do not stop the render loop when all wanted tiles were aborted due to
        // a small, saturated tile cache.
        this.tileChangeCallback_();
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/~/openlayers/oms/tilequeue.js
// module id = 24
// module chunks = 0